// import React, { useState ,useRef} from "react";
// import {
//   FormControl,
//   FormLabel,
//   FormErrorMessage,
//   FormHelperText,
//   Input,
//   VStack,
//   HStack,
//   RadioGroup,
//   Radio,
//   Select,
//   Button,
//   Center,
//   Box,
//   Img,
//   Avatar,Text
// } from "@chakra-ui/react";
// // Import your CSS file for styling
// import useRazorpay from "react-razorpay";
// import axios from "axios";
// import {useNavigate} from "react-router-dom"
// import jsPDF from 'jspdf';
// import {PDFDownloadLink} from '@react-pdf/renderer'
// import { MyDocument } from "./admitCard";

// const MyForm = () => {
//   const [Razorpay, isLoaded] = useRazorpay();
//   const fileInputRef = useRef(null);
//   const navigate=useNavigate()
//   const [formData, setFormData] = useState({
//     registrationno: Math.floor(100000 + Math.random() * 900000),
//     name: "",
//     fathername: "",
//     gender: "",
//     dateofbirth: "",
//     address: "",
//     mobileno: "",
//     img: "",
//     fees: "",

//   });
//   const [compressedImage, setCompressedImage] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [saveData,setSavaData]=useState({id:''})

//   const handleInputChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//   };
//   const isFormValid = Object.values(formData).every((value) => value !== '');
//   const handleImageChange = async (e) => {
//     const selectedFile = e.target.files[0];

//     try {
//       const compressImage = (file, maxSizeKB) => {
//         return new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.readAsDataURL(file);

//           reader.onload = (event) => {
//             const img = new Image();
//             img.src = event.target.result;

//             img.onload = () => {
//               const canvas = document.createElement('canvas');
//               const ctx = canvas.getContext('2d');
//               const maxWidth = 100; // Adjust the maximum width as needed

//               let width = img.width;
//               let height = img.height;

//               if (width > maxWidth) {
//                 height *= maxWidth / width;
//                 width = maxWidth;
//               }

//               canvas.width = width;
//               canvas.height = height;

//               ctx.drawImage(img, 0, 0, width, height);

//               const compressedDataURL = canvas.toDataURL('image/jpeg', 0.7); // Adjust quality as needed

//               // Convert base64-encoded string to bytes (each character represents a byte)
//               var byteCharacters = atob(compressedDataURL.split(',')[1]);
//               var byteNumbers = new Array(byteCharacters.length);

//               for (let i = 0; i < byteCharacters.length; i++) {
//                 byteNumbers[i] = byteCharacters.charCodeAt(i);
//               }

//               var byteArray = new Uint8Array(byteNumbers);

//               var imageSizeInBytes = byteArray.length; // Size of the image in bytes
//               var maxSizeInKB = 20;
//               var maxSizeInBytes = maxSizeInKB * 1024;

//               if (imageSizeInBytes <= maxSizeInBytes) {
//                 window.alert("Image Upload successfully");
//               } else {
//                 window.alert("Image size exceeds the maximum allowed size of " + maxSizeInKB + " KB.");
//               }

//               console.log(imageSizeInBytes)
//               console.log(compressedDataURL)
//               resolve(compressedDataURL);
//             };

//             img.onerror = (error) => {
//               reject(error);
//             };
//           };

//           reader.onerror = (error) => {
//             reject(error);
//           };
//         });
//       };

//       const compressedDataURL = await compressImage(selectedFile, 50); // 50 KB target size
//       setCompressedImage(compressedDataURL);
//       handleInputChange("img",compressedDataURL)
//     } catch (error) {
//       console.error('Error compressing image:', error);
//     }
//   };

//   const initiatePayment = async (e) => {
//     setIsLoading(true);
//     console.log(formData);

//     try {
//       const { data: order } = await axios.post(
//         `${process.env.REACT_APP_BACKEND_URL}/api/payment`,
//         formData
//       );

//       const options = {
//         key: "rzp_test_u743lHilR2AxPn", // Replace with your Razorpay Key
//         amount: formData.fees,
//         currency: "INR", // or your currency code
//         name: "SB Pathshala",
//         description: "Registration Fees",
//         image:"https://user-images.githubusercontent.com/103061012/228309246-6ac642a0-9a14-4de7-8f6e-7e167143435b.png",
//         order_id: order.id,
//         handler:  async function (response) {
//           try {
//             const paymentResult = {
//               id: response.razorpay_payment_id,
//               order_id: response.razorpay_order_id,
//               signature: response.razorpay_signature,
//             };

//             const paymentid=paymentResult.id
//             const  res=await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/register`,{formData,paymentid})

//             setSavaData(res.data)
//             console.log(res.data)
//           } catch (error) {
//            console.log('Payment failed', { variant: 'error' },error);
//           }
//         },
//         prefill: {
//           name: formData.name,
//           contact: formData.mobileno,
//         },
//         notes: {
//           address: formData.address,
//         },
//       };

//       function loadScript(url) {
//         return new Promise((resolve, reject) => {
//           const script = document.createElement("script");
//           script.src = url;
//           script.onload = resolve;
//           script.onerror = reject;
//           document.head.appendChild(script);
//         });
//       }
//       const scriptLoaded = await loadScript(
//         "https://checkout.razorpay.com/v1/checkout.js"
//       );

//       if (scriptLoaded) {
//         const rzpay = new Razorpay(options);
//         rzpay.open();

//       } else {
//         alert("Razorpay Not working");
//       }

//     } catch (error) {
//       alert(error, "error");
//     }
//     setFormData({
//       registrationno: Math.floor(100000 + Math.random() * 900000),
//       name: "",
//       fathername: "",
//       gender: "",
//       dateofbirth: "",
//       address: "",
//       mobileno: "",
//       img: "",
//       fees:""
//     })
//     setCompressedImage(null)
//     handleReset()
//     setIsLoading(false);
//   };

//   const handleReset = () => {
//     // Reset the file input by clearing its value
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };
//    function Change(e){
//     handleImageChange(e)
//    }

//   return (
//     <>
//     {!saveData.id ? (
//       <form onSubmit={initiatePayment}>
//     <VStack w={["80vw", "80vw", 500]} pb={"20px"} pt="6px">
//       <HStack>
//         <Text fontFamily={"Arvo"} fontWeight='bold' color="blue.400">
//          Registration Number:{formData.registrationno}
//         </Text>
//       </HStack>

//       <FormControl isRequired>
//         <HStack>
//           <FormLabel w={"200px"}>Name</FormLabel>
//           <Input
//             placeholder="Enter Your Full Name"
//             value={formData.name}
//             onChange={(e) => handleInputChange("name", e.target.value)}
//           />
//         </HStack>
//       </FormControl>
//       <FormControl isRequired>
//         <HStack>
//           <FormLabel w={"200px"}>Father Name</FormLabel>
//           <Input
//             placeholder="Enter Your Father Name"
//             value={formData.fathername}
//             onChange={(e) => handleInputChange("fathername", e.target.value)}
//           />
//         </HStack>
//       </FormControl>
//       <FormControl as="fieldset" isRequired>
//         <HStack>
//           <FormLabel as="legend" w={"200px"}>
//             Gender
//           </FormLabel>
//           <RadioGroup
//             defaultValue="Itachi"
//             ml="0px"
//             value={formData.gender}
//             onChange={(value) => handleInputChange("gender", value)}
//           >
//             <HStack spacing={"24px"}>
//               <Radio value="male">Male</Radio>
//               <Radio value="female">Female</Radio>
//               <Radio value="other">Other</Radio>
//             </HStack>
//           </RadioGroup>
//         </HStack>
//       </FormControl>
//       <FormControl isRequired>
//         <HStack>
//           <FormLabel w={"200px"}>Date of Birth</FormLabel>
//           <Input
//             placeholder="Enter Your Date Of Birth"
//             type="date"
//             value={formData.dateofbirth}
//             onChange={(e) => handleInputChange("dateofbirth", e.target.value)}
//           />
//         </HStack>
//       </FormControl>
//       <FormControl isRequired>
//         <HStack>
//           <FormLabel w={"200px"}>Mobile Number</FormLabel>
//           <Input
//             placeholder="Enter Your Mobile Number"
//             value={formData.mobileno}
//             onChange={(e) => handleInputChange("mobileno", e.target.value)}
//           />
//         </HStack>
//       </FormControl>
//       <FormControl isRequired>
//         <HStack>
//           <FormLabel w={"200px"}>Address</FormLabel>
//           <Input
//             placeholder="Enter Your Address"
//             value={formData.address}
//             onChange={(e) => handleInputChange("address", e.target.value)}
//           />
//         </HStack>
//       </FormControl>
//       <FormControl as="fieldset" isRequired>
//         <HStack>
//           <FormLabel as="legend" w={"200px"}>
//             Scholarship Category
//           </FormLabel>
//           <RadioGroup
//             defaultValue="Itachi"
//             ml="0px"
//             value={formData.fees}
//             onChange={(value) => handleInputChange("fees", value)}
//           >
//             <HStack spacing={"24px"}>
//               <Radio value="250">Fees 250Rs</Radio>
//               <Radio value="1000">Fees 1000Rs</Radio>
//               <Radio value="1250">Fees 1250Rs</Radio>
//             </HStack>
//           </RadioGroup>
//         </HStack>
//       </FormControl>
//       <FormControl isRequired>
//         <HStack>
//           <FormLabel w={"200px"}>Image</FormLabel>
//           <Avatar src={compressedImage}  bg='teal.500' />

//           <Input
//             type="file"
//             onChange={(e)=>Change(e)}
//             ref={fileInputRef}
//           />

//         </HStack>
//       </FormControl>

//       <HStack>
//         <Button
//           colorScheme="teal"
//           type="submit"
//           size="lg"

//           isLoading={isLoading}

//         >
//           Payment
//         </Button>
//       </HStack>
//     </VStack>
//     </form>
//     )
//     :

//     (
//     <>
//     <VStack p="10px">
//     <VStack p="10px">
//       <Box w={[200, 300, 400]} h="25vh" borderRadius={"10px"}  padding={"5px"} boxShadow="0 0 10px rgba(128, 128, 128, 0.5)" >
//         <VStack w="100%">
//           <Center>
//           <VStack>
//             <HStack w={"100%"} fontFamily={"Arvo"}>
//               <span>Registration Number</span>
//               <span>{saveData.registrationno}</span>
//             </HStack>
//             <HStack w={"100%"} fontFamily={"Arvo"}>
//               <span >Name</span>
//               <span>{saveData.name}</span>
//             </HStack>
//             <HStack w={"100%"} fontFamily={"Arvo"}>
//               <span>Fee</span>
//               <span>{saveData.fees}</span> {/* Replace with the actual fee value */}
//             </HStack>
//             <HStack w={"100%"} fontFamily={"Arvo"}>
//               <span>Payment</span>
//               <span>Success</span> {/* Replace with the actual fee value */}
//             </HStack>
//             </VStack>
//           </Center>
//         </VStack>
//       </Box>
//     </VStack>
//       <Button colorScheme='blue'>
//     <PDFDownloadLink document={<MyDocument props={saveData} />} fileName="somename.pdf">
//         {({ blob, url, loading, error }) =>
//           loading ? "Admit Card Loading..." : "Download Admit Card "
//         }
//       </PDFDownloadLink>
//       </Button>
//       </VStack>
//     </>

//     )

//     }
//     </>
//   );
// };

// export default MyForm

import React, { useRef, useState } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightElement,
  Textarea,
  SimpleGrid,
  HStack,
  Button,
  RadioGroup,
  Radio,
  Stack,
  Text,
  VStack,
  Checkbox,
  InputLeftElement,
  Select,
  Center,
  Spinner
} from "@chakra-ui/react";
import ProfilePictureBox from "./profilePicture";
import useRazorpay from "react-razorpay";
import axios from "axios";
import { useToast } from '@chakra-ui/react'
import {PDFDownloadLink} from '@react-pdf/renderer'
import { MyDocument } from "./admitCard";


const MyForm = () => {
  const toast = useToast() 
  const [Razorpay, isLoaded] = useRazorpay();
  const [formData, setFormData] = useState({
    registrationno: Math.floor(100000 + Math.random() * 900000),
    name: "",
    fathername: "",
    aadharno: "",
    gender: "",
    dateofbirth: "",

    state: "",
    city: "",
    village: "",
    post: "",
    pincode: "",

    mobileno: "",
    img: "",
    fees: "",
    category: "",
    aim: "",
    schoolname: "",
    teachername: "",
    teacherno: "",
  });
  const [compressedImage, setCompressedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [saveData, setSavaData] = useState({ id: "" });
  const [imageFile, setImageFile] = useState(null);
  const [paymentRazorpayId,setPaymentRazorpayId]=useState(null)
  const fileInputRef = useRef(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };



  console.log(formData)

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleImageUpload = async (e) => {
    const selectedFile = e.target.files[0];

    try {
      const compressImage = (file, maxSizeKB) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onloadend = () => {
            let imageDataUrl = reader.result;
            setImageFile(imageDataUrl);
          };

          reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              const maxWidth = 100; // Adjust the maximum width as needed

              let width = img.width;
              let height = img.height;

              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }

              canvas.width = width;
              canvas.height = height;

              ctx.drawImage(img, 0, 0, width, height);

              const compressedDataURL = canvas.toDataURL("image/jpeg", 0.7); // Adjust quality as needed

              // Convert base64-encoded string to bytes (each character represents a byte)
              var byteCharacters = atob(compressedDataURL.split(",")[1]);
              var byteNumbers = new Array(byteCharacters.length);

              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }

              var byteArray = new Uint8Array(byteNumbers);

              var imageSizeInBytes = byteArray.length; // Size of the image in bytes
              var maxSizeInKB = 20;
              var maxSizeInBytes = maxSizeInKB * 1024;

              if (imageSizeInBytes <= maxSizeInBytes) {
                window.alert("Image Upload successfully");
              } else {
                window.alert(
                  "Image size exceeds the maximum allowed size of " +
                    maxSizeInKB +
                    " KB."
                );
              }

              console.log(imageSizeInBytes);
              console.log(compressedDataURL);
              resolve(compressedDataURL);
            };

            img.onerror = (error) => {
              reject(error);
            };
          };

          reader.onerror = (error) => {
            reject(error);
          };
        });
      };

      const compressedDataURL = await compressImage(selectedFile, 50); // 50 KB target size
      setCompressedImage(compressedDataURL);
      handleChange("img", compressedDataURL);
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };


 const initiatePayment = async (e) => {
  e.preventDefault()
  if(imageFile==null){
    alert("Upload Your Photo")
    return ;
  }
  if(!isChecked){
    alert("Trick The Terms")
    return ;
  }
    setIsLoading(true);
    console.log(formData);

    try {
      const { data: order } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/payment`,
        formData
      );

      const options = {
        key: "rzp_test_u743lHilR2AxPn", // Replace with your Razorpay Key
        amount: formData.fees,
        currency: "INR", // or your currency code
        name: "SB Pathshala",
        description: "Registration Fees",
        image:"https://user-images.githubusercontent.com/103061012/228309246-6ac642a0-9a14-4de7-8f6e-7e167143435b.png",
        order_id: order.id,
        handler:  async function (response) {
          try {
            const paymentResult = {
              id: response.razorpay_payment_id,
              order_id: response.razorpay_order_id,
              signature: response.razorpay_signature,
            };
          console.log(paymentResult)
            const paymentid=paymentResult.id
            setPaymentRazorpayId(paymentid)
            const  res=await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/register`,{formData,paymentid})
            setSavaData(res.data)
            toast({
              title: 'Payment Success',
              description: "",
              status: 'success',
              duration: 9000,
              isClosable: true,
              position: 'bottom-center',
            })
            setIsLoading(false);
          } catch (error) {
            toast({
              title: 'Payment Failed',
              description: "",
              status: 'error',
              duration: 9000,
              isClosable: true,
              position: 'bottom-center',
            })
            setIsLoading(false);
            setImageFile(null)
           console.log('Payment failed', { variant: 'error' },error);
          }
        },
        prefill: {
          name: formData.name,
          contact: formData.mobileno,
         
        },
        notes: {
          address: {
           state: formData.state,
           city: formData.city,
           village:formData.village,
           post:formData.post,
           pincode:formData.pincode
          },
          personalDetails:{
            fathername:formData.fathername,
            dateofbirth:formData.dateofbirth,
            aim:formData.aim,
            category:formData.category,
            gender:formData.gender
          }
        },
      };

      function loadScript(url) {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      const scriptLoaded = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (scriptLoaded) {
        const rzpay = new Razorpay(options);
        rzpay.open();
        
      } else {
        alert("Razorpay Not working");
        setIsLoading(false);
        setImageFile(null)
      }

    } catch (error) {
      alert(error, "error");
      setIsLoading(false);
      setImageFile(null)
    }
   
    setFormData({
      registrationno: Math.floor(100000 + Math.random() * 900000),
      name: "",
      fathername: "",
      aadharno: "",
      gender: "",
      dateofbirth: "",
  
      state: "",
      city: "",
      village: "",
      post: "",
      pincode: "",
  
      mobileno: "",
      img: "",
      fees: "",
      category: "",
      aim: "",
      schoolname: "",
      teachername: "",
      teacherno: "",
    })
    setCompressedImage(null)
    
    setIsChecked(!isChecked)
  };

  

  return (
  <>
  {!saveData.id ? 
  !isLoading?
  (
    <Box >
      <Box display={"flex"} justifyContent={"center"} >
        <form onSubmit={(e)=>initiatePayment(e)}>
          <Box
            display={"flex"}
            gap={{ base: "25px", lg: "15px" }}
            flexDir={{ base: "column", lg: "row" }}
            alignItems={{ base: "center", lg: "start" }}
            // backgroundColor={"blue.100"}
            rounded={"lg"}
            p="20px"
          >
         
            <ProfilePictureBox
              imageFile={imageFile}
              handleImageUpload={handleImageUpload}
              fileInputRef={fileInputRef}
            />
          
            <Box w={"100%"} display={"flex"} flexDir={"column"} gap={"16px"}>
              <SimpleGrid columns={[1, 1, 2]} gap={"16px"}>
                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Name
                  </FormLabel>
                  <Input
                    padding="12px"
                    borderRadius="8px"
                    border="1px solid #CCC"
                    backgroundColor="#fff"
                    alignSelf="stretch"
                    type={"text"}
                    placeholder="Enter Full Name"
                    _placeholder={{
                      fontSize: ["14px", null, null, "16px"],
                    }}
                    focusBorderColor="#4358F6"
                    _focus={{
                      boxShadow: "0 0 0 0.2px #4358F6",
                      outline: "none",
                    }}
                    name="name"
                    value={formData.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Father Name
                  </FormLabel>
                  <InputGroup>
                    <Input
                      padding="12px"
                      borderRadius="8px"
                      border="1px solid #CCC"
                      backgroundColor="#fff"
                      alignSelf="stretch"
                      type={"text"}
                      placeholder="Enter your Father Name"
                      _placeholder={{
                        fontSize: ["14px", null, null, "16px"],
                      }}
                      focusBorderColor="#4358F6"
                      _focus={{
                        boxShadow: "0 0 0 0.2px #4358F6",
                      }}
                      pr="40px"
                      name="github"
                      value={formData.fathername}
                      onChange={(e) =>
                        handleChange("fathername", e.target.value)
                      }
                    />
                  </InputGroup>
                </FormControl>
                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    AAdhar Number
                  </FormLabel>
                  <InputGroup>
                    <Input
                      padding="12px"
                      borderRadius="8px"
                      border="1px solid #CCC"
                      backgroundColor="#fff"
                      alignSelf="stretch"
                      type={"number"}
                      placeholder="Enter your AAdhar Number"
                      _placeholder={{
                        fontSize: ["14px", null, null, "16px"],
                      }}
                      focusBorderColor="#4358F6"
                      _focus={{
                        boxShadow: "0 0 0 0.2px #4358F6",
                      }}
                      pr="40px"
                      name="github"
                      value={formData.aadharno}
                      onChange={(e) => handleChange("aadharno", e.target.value)}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Mobile Number
                  </FormLabel>
                  <Input
                    padding="12px"
                    borderRadius="8px"
                    border="1px solid #CCC"
                    backgroundColor="#fff"
                    alignSelf="stretch"
                    type={"number"}
                    placeholder="Enter your Mobile Name "
                    _placeholder={{
                      fontSize: ["14px", null, null, "16px"],
                    }}
                    focusBorderColor="#4358F6"
                    _focus={{
                      boxShadow: "0 0 0 0.2px #4358F6",
                    }}
                    name="phone"
                    value={formData.mobileno}
                    onChange={(e) => handleChange("mobileno", e.target.value)}
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Gender
                  </FormLabel>
                  <RadioGroup
                    value={formData.gender}
                    onChange={(value) => handleChange("gender", value)}
                  >
                    <Stack direction="row">
                      <Radio value="Male">Male</Radio>
                      <Radio value="Female">Female</Radio>
                      <Radio value="Other">Other</Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Category
                  </FormLabel>
                  <RadioGroup
                    value={formData.category}
                    onChange={(value) => handleChange("category", value)}
                  >
                    <Stack direction="row">
                      <Radio value="General">General</Radio>
                      <Radio value="OBC">OBC</Radio>
                      <Radio value="SC/ST">SC/ST</Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                <FormControl isRequired>
                  <HStack>
                    <VStack align="start">
                      <FormLabel
                        color="#21191B"
                        fontFamily={"Open Sans"}
                        fontSize="14px"
                        fontWeight="600"
                        lineHeight="24px"
                      >
                        State
                      </FormLabel>
                      <Input
                        padding="12px"
                        borderRadius="8px"
                        border="1px solid #CCC"
                        backgroundColor="#fff"
                        alignSelf="stretch"
                        type={"text"}
                        placeholder="State"
                        _placeholder={{
                          fontSize: ["14px", null, null, "16px"],
                        }}
                        focusBorderColor="#4358F6"
                        _focus={{
                          boxShadow: "0 0 0 0.2px #4358F6",
                        }}
                        name="State"
                        value={formData.state}
                        onChange={(e) => handleChange("state", e.target.value)}
                      />
                    </VStack>
                    <VStack align="start">
                      <FormLabel
                        color="#21191B"
                        fontFamily={"Open Sans"}
                        fontSize="14px"
                        fontWeight="600"
                        lineHeight="24px"
                      >
                        City
                      </FormLabel>
                      <Input
                        padding="12px"
                        borderRadius="8px"
                        border="1px solid #CCC"
                        backgroundColor="#fff"
                        alignSelf="stretch"
                        type={"text"}
                        placeholder="City"
                        _placeholder={{
                          fontSize: ["14px", null, null, "16px"],
                        }}
                        focusBorderColor="#4358F6"
                        _focus={{
                          boxShadow: "0 0 0 0.2px #4358F6",
                        }}
                        name="city"
                        value={formData.city}
                        onChange={(e) => handleChange("city", e.target.value)}
                      />
                    </VStack>
                  </HStack>
                </FormControl>
                <FormControl isRequired>
                  <HStack>
                    <VStack align={"start"}>
                      <FormLabel
                        color="#21191B"
                        fontFamily={"Open Sans"}
                        fontSize="14px"
                        fontWeight="600"
                        lineHeight="24px"
                      >
                        Village
                      </FormLabel>
                      <Input
                        padding="12px"
                        borderRadius="8px"
                        border="1px solid #CCC"
                        backgroundColor="#fff"
                        alignSelf="stretch"
                        type={"text"}
                        placeholder="Village"
                        _placeholder={{
                          fontSize: ["14px", null, null, "16px"],
                        }}
                        focusBorderColor="#4358F6"
                        _focus={{
                          boxShadow: "0 0 0 0.2px #4358F6",
                        }}
                        name="state"
                        value={formData.village}
                        onChange={(e) =>
                          handleChange("village", e.target.value)
                        }
                      />
                    </VStack>
                    <VStack align={"start"}>
                      <FormLabel
                        color="#21191B"
                        fontFamily={"Open Sans"}
                        fontSize="14px"
                        fontWeight="600"
                        lineHeight="24px"
                      >
                        Post
                      </FormLabel>
                      <Input
                        padding="12px"
                        borderRadius="8px"
                        border="1px solid #CCC"
                        backgroundColor="#fff"
                        alignSelf="stretch"
                        type={"text"}
                        placeholder="Post"
                        _placeholder={{
                          fontSize: ["14px", null, null, "16px"],
                        }}
                        focusBorderColor="#4358F6"
                        _focus={{
                          boxShadow: "0 0 0 0.2px #4358F6",
                        }}
                        name="city"
                        value={formData.post}
                        onChange={(e) => handleChange("post", e.target.value)}
                      />
                    </VStack>
                    <VStack align={"start"}>
                      <FormLabel
                        color="#21191B"
                        fontFamily={"Open Sans"}
                        fontSize="14px"
                        fontWeight="600"
                        lineHeight="24px"
                      >
                        Pin Code
                      </FormLabel>
                      <Input
                        padding="12px"
                        borderRadius="8px"
                        border="1px solid #CCC"
                        backgroundColor="#fff"
                        alignSelf="stretch"
                        type={"number"}
                        placeholder="Pin Code"
                        _placeholder={{
                          fontSize: ["14px", null, null, "16px"],
                        }}
                        focusBorderColor="#4358F6"
                        _focus={{
                          boxShadow: "0 0 0 0.2px #4358F6",
                        }}
                        name="pincode"
                        value={formData.pincode}
                        onChange={(e) =>
                          handleChange("pincode", e.target.value)
                        }
                      />
                    </VStack>
                  </HStack>
                </FormControl>
                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Date Of Birth
                  </FormLabel>
                  <Input
                    padding="12px"
                    borderRadius="8px"
                    border="1px solid #CCC"
                    backgroundColor="#fff"
                    alignSelf="stretch"
                    type={"date"}
                    placeholder="Enter your Date Of Birth"
                    _placeholder={{
                      fontSize: ["14px", null, null, "16px"],
                    }}
                    focusBorderColor="#4358F6"
                    _focus={{
                      boxShadow: "0 0 0 0.2px #4358F6",
                    }}
                    name="dateofbirth"
                    value={formData.dateofbirth}
                    onChange={(e) =>
                      handleChange("dateofbirth", e.target.value)
                    }
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    10th School Name & Address
                  </FormLabel>
                  <InputGroup>
                    <Input
                      padding="12px"
                      borderRadius="8px"
                      border="1px solid #CCC"
                      backgroundColor="#fff"
                      alignSelf="stretch"
                      type={"text"}
                      placeholder="Enter your school name and address"
                      _placeholder={{
                        fontSize: ["14px", null, null, "16px"],
                      }}
                      focusBorderColor="#4358F6"
                      _focus={{
                        boxShadow: "0 0 0 0.2px #4358F6",
                      }}
                      pr="40px"
                      name="github"
                      value={formData.schoolname}
                      onChange={(e) =>
                        handleChange("schoolname", e.target.value)
                      }
                    />
                    <InputRightElement>
                      {/* <Image src={githubInputIcon} alt="" /> */}
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <FormControl isRequired>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Scholarship Registration Fees
                  </FormLabel>
                  <RadioGroup
                    value={formData.fees}
                    onChange={(value) => handleChange("fees", value)}
                  >
                    <Stack direction="row">
                      <Radio value="250">250 Fees</Radio>
                      <Radio value="1000">1000 Fees</Radio>
                      <Radio value="1250">1250 Fees</Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                <FormControl>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Your Aim
                  </FormLabel>
                  <Select
                    placeholder="Select Your Aim"
                    value={formData.aim}
                    onChange={(e) => handleChange("aim", e.target.value)}
                  >
                    <option value="ITT JEE">IIT JEE</option>
                    <option value="NEET">NEET</option>
                    <option value="Board">
                      Only Preparing For The Board Exams
                    </option>
                    <option value="Not Decided">Not Decided</option>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Guided by (Teacher's Name) Optional
                  </FormLabel>
                  <InputGroup>
                    <Input
                      padding="12px"
                      borderRadius="8px"
                      border="1px solid #CCC"
                      backgroundColor="#fff"
                      alignSelf="stretch"
                      type={"text"}
                      placeholder="Enter your Teacher's Name"
                      _placeholder={{
                        fontSize: ["14px", null, null, "16px"],
                      }}
                      focusBorderColor="#4358F6"
                      _focus={{
                        boxShadow: "0 0 0 0.2px #4358F6",
                      }}
                      pr="40px"
                      name="teachername"
                      value={formData.teachername}
                      onChange={(e) =>
                        handleChange("teachername", e.target.value)
                      }
                    />
                    <InputRightElement>
                      {/* <Image src={githubInputIcon} alt="" /> */}
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <FormControl>
                  <FormLabel
                    color="#21191B"
                    fontFamily={"Open Sans"}
                    fontSize="14px"
                    fontWeight="600"
                    lineHeight="24px"
                  >
                    Your Teacher Mobile Number(Optional)
                  </FormLabel>
                  <InputGroup>
                    <Input
                      padding="12px"
                      borderRadius="8px"
                      border="1px solid #CCC"
                      backgroundColor="#fff"
                      alignSelf="stretch"
                      type={"text"}
                      placeholder="Enter your Teacher Mobile Number"
                      _placeholder={{
                        fontSize: ["14px", null, null, "16px"],
                      }}
                      focusBorderColor="#4358F6"
                      _focus={{
                        boxShadow: "0 0 0 0.2px #4358F6",
                      }}
                      pr="40px"
                      name="teacherno"
                      value={formData.teacherno}
                      onChange={(e) =>
                        handleChange("teacherno", e.target.value)
                      }
                    />
                  </InputGroup>
                </FormControl>
              </SimpleGrid>
              <VStack align="start" >
                <Checkbox  fontFamily={"Open Sans"} onChange={handleCheckboxChange}>
                  I certify that the information I have written in the
                  application form is true and accurate to the best of my
                  knowledge.Providing false or misleading information will result in the denial of the scholarship.
                  And   I understand all the terms and conditions for the scholarship and agree to abide by them.
                </Checkbox>
               
                <Button type="submit" colorScheme="blue" isLoading={isLoading} size={"lg"}>
                  Payment
                </Button>
              </VStack>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
    ):
    <Box textAlign="center">
      <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='xl' />
      <Box mt={4} fontWeight={"bold"}>Processing</Box>
    </Box>
      :(
    <>
     <VStack p="10px" >
     <VStack p="10px">
     <h4 style={{fontFamily:'fantasy',color:'blueviolet'}}>You Are Eligible For Scholarship Test</h4>
       <Box w={[200, 300, 400]}  backgroundColor={"gray.500"} color={"white"} h="25vh" borderRadius={"10px"}  padding={"5px"} boxShadow="0 0 10px rgba(128, 128, 128, 0.5)" >
         <VStack w="100%">
           <Center>
           <VStack >
             <HStack w={"100%"} fontFamily={"Arvo"}>
               <span>Registration Number:</span>
              <span>{saveData.registrationno}</span>
            </HStack>
             <HStack w={"100%"} fontFamily={"Arvo"}>
               <span >Name:</span>
               <span>{saveData.name}</span>
            </HStack>
             <HStack w={"100%"} fontFamily={"Arvo"}>
              <span>Fee:</span>
               <span>{saveData.fees}</span> {/* Replace with the actual fee value */}
           </HStack>
             <HStack w={"100%"} fontFamily={"Arvo"}>
               <span>Payment:</span>
              <span>Success</span> {/* Replace with the actual fee value */}
             </HStack>
            </VStack>
          </Center>
         </VStack>
       </Box>
     </VStack>
       <Button colorScheme='blue'>
     <PDFDownloadLink document={<MyDocument props={saveData} imageFile={imageFile}/>} fileName="somename.pdf">
         {({ blob, url, loading, error }) =>
           loading ? "Admit Card Loading..." : "Download Admit Card "
         }
       </PDFDownloadLink>
       </Button>
       </VStack>
    </>
     )
    
  }
  </>
  );
};

export default MyForm;
